// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__Rj4wz","photo":"styles_photo__1Qsvj","text":"styles_text__Ery9l"};